// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3Ne2I","loaderOuter":"PageOverlayLoader_loaderOuter__toySp"};